import React from 'react'
import PropTypes from 'prop-types'
/* --------------------------------------------- */
const EditPencilIcon = ({ color, ...rest }) => (

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30" {...rest} >
        <path fill={color} fill-rule="evenodd" d="M18.137 0c1.296 0 2.35 1.017 2.35 2.268v1.845h6.821c.517 0 .937.42.937.938 0 .517-.42.937-.937.937h-2.445l-.897 19.827c0 2.289-1.895 4.185-4.226 4.185H9.443c-2.33 0-4.226-1.896-4.226-4.227L4.32 5.988H1.875c-.518 0-.937-.42-.937-.938s.419-.937.937-.937h6.82V2.268C8.695 1.018 9.75 0 11.046 0zm4.85 5.988H6.196l.894 19.743c0 1.34 1.055 2.394 2.352 2.394H19.74c1.297 0 2.352-1.055 2.352-2.352l.894-19.785zm-8.395 3.716c.517 0 .937.42.937.938V23.47c0 .518-.42.937-.937.937-.518 0-.938-.42-.938-.938V10.643c0-.518.42-.938.938-.938zm-4.437.494c.518 0 .938.419.938.937v11.842c0 .518-.42.938-.938.938s-.938-.42-.938-.938V11.135c0-.518.42-.937.938-.937zm8.873 0c.517 0 .937.419.937.937v11.842c0 .518-.42.938-.937.938-.518 0-.938-.42-.938-.938V11.135c0-.518.42-.937.938-.937zm-.89-8.323h-7.092c-.258 0-.476.18-.476.393v1.845h8.043V2.268c0-.214-.218-.393-.476-.393z" />
    </svg>




)
/* --------------------------------------------- */
EditPencilIcon.propTypes = {
    /** Color of icon. */
    color: PropTypes.string,
    /** Icon css styles. */
    style: PropTypes.object
}
/* --------------------------------------------- */
EditPencilIcon.defaultProps = {
    color: 'transparent',

}
/* --------------------------------------------- */
export default EditPencilIcon
/* --------------------------------------------- */
